import Vue from 'vue'
import Vuex from 'vuex'
import snackbarModule from './snackbarModule'
import loginModule from './loginModule'

Vue.use(Vuex)

const state = {
  isLoading: false,
  appModule: ''
}

const getters = {
  isLoading: state => state.isLoading,
  appModule: state => state.appModule
}

const actions = {
  changeLoadingStatus (context, isLoading) {
    context.commit('changeLoadingStatus', isLoading)
  },
  changeAppModule (context, appModule) {
    context.commit('changeAppModule', appModule)
  }
}

const mutations = {
  changeLoadingStatus (state, isLoading) {
    if (typeof isLoading !== 'boolean') {
      isLoading = false
    }
    state.isLoading = isLoading
  },
  changeAppModule (state, appModule) {
    state.appModule = appModule
  }
}

export default new Vuex.Store({
  modules: {
    snackbarModule,
    loginModule
  },
  state,
  getters,
  actions,
  mutations
})
